export const SWITCH_BACKGROUND = 'SWITCH_BACKGROUND'
export const SET_BG_CALIBRATION = 'SET_BG_CALIBRATION'

export const MOVE_FRAME_SIMPLE = 'MOVE_FRAME_SIMPLE'
export const MOVE_FRAME = 'MOVE_FRAME'
export const MOVE_SET_SIMPLE = 'MOVE_SET_SIMPLE'
export const MOVE_SET = 'MOVE_SET'
export const SPLIT_SET = 'SPLIT_SET'
export const MERGE_SET = 'MERGE_SET'

export const INSERT_FRAME = 'INSERT_FRAME'
export const REMOVE_FRAME = 'REMOVE_FRAME'
export const COPY_FRAME = 'COPY_FRAME'
export const SELECT_FRAME = 'SELECT_FRAME_SIZE'
export const ROTATE_FRAME = 'ROTATE_FRAME'
export const DESELECT_FRAME = 'DESELECT_FRAME_SIZE'
export const UPDATE_WALLPAPER = 'UPDATE_WALLPAPER'
export const UPDATE_WALLPAPER_DIM = 'UPDATE_WALLPAPER_DIM'

export const INSERT_SET = 'INSERT_SET'
export const SELECT_SET = 'SELECT_FRAME_SET'
export const REMOVE_SET = 'REMOVE_SET'
export const REMOVE_SETS = 'REMOVE_SETS'

export const RESIZE_FRAME = 'RESIZE_FRAME_SIZE'
export const FINISH_RESIZING_FRAME = 'FINISH_RESIZING_FRAME'
export const DISALLOW_TO_RESIZE = 'DISALLOW_TO_RESIZE'
export const ALLOW_TO_RESIZE = 'ALLOW_TO_RESIZE'

export const CHANGE_BORDER_COLOR = 'CHANGE_BORDER_COLOR'
export const CHANGE_BORDER_TYPE = 'CHANGE_BORDER_TYPE'

export const SELECT_PHOTO = 'SELECT_PHOTO'
export const RENAME_PROJECT = 'RENAME_PROJECT'
export const SAVE_PROJECT = 'SAVE_WHOLE_PROJECT'
export const LOAD_PROJECT = 'LOAD_WHOLE_PROJECT'
export const CREATED_PROJECT = 'CREATED_PROJECT'

export const START_CROPPING = 'START_CROPPING'
export const REFRESH_CROP_VALUES_PICTURE = 'REFRESH_CROP_VALUES_PICTURE'
export const REFRESH_CROP_VALUES_BACKGROUND = 'REFRESH_CROP_VALUES_BACKGROUND'



// WEBPACK FOOTER //
// ./src/constants/projectActions.js